import { render, staticRenderFns } from "./FormThanhToan.vue?vue&type=template&id=43195ef4&scoped=true&"
import script from "./FormThanhToan.vue?vue&type=script&lang=js&"
export * from "./FormThanhToan.vue?vue&type=script&lang=js&"
import style0 from "./FormThanhToan.vue?vue&type=style&index=0&id=43195ef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43195ef4",
  null
  
)

export default component.exports